import { injectGlobal } from '@bd/bdui-styles/emotion';
import colors from './colors';

injectGlobal(`
  @media (min-width: 1400px) {
    .container {
      max-width: 1300px;
    }
  }
  @media (min-width: 1700px) {
    .container {
      max-width: 1600px;
    }
  }
  .btn {
    background-color: ${colors.color2};
    transition: all .25s ease;
    color: ${colors.white} !important;
    border-radius: 0;
    border:1px solid #ddd;
    padding: 15px 20px;
    font-weight: 700;
    text-transform:uppercase;
    &:hover {
      background-color: ${colors.color2Darker};
      color: ${colors.white};
    }
  }
  .btn-reverse {
    display: inline-block;
    line-height: 38px;
    height: 40px;
    margin: 0 10px 0 0;
    cursor: pointer;
    color: white;
    background-color: ${colors.color2};
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    border: 0;
    padding: 0 10px;
    border: 1px solid ${colors.color2};
    border-radius: 5px;
    &:hover {
      background-color: ${colors.color2Darker};
      color: white;
    }
  }
  .blockit {
    display:block;
    width:100%;
  }
  .brand-color {
    color:${colors.color2};
  }
  a, a:link, a:hover {
    text-decoration:none;
    color:${colors.color2};
  }
  .btn_callToday {
    width:100%;
    margin-bottom:10px;
    color:${colors.color1};
    border-radius: 5px;
    background:white;
    &:hover {
      background-color:white;
      color:${colors.color1Darkest};
    }
  }
`);



// WEBPACK FOOTER //
// ./src/styles/reset.js